import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ThemeProvider from './utils/themes/ThemeProvider';
import OrganizationsPage from './pages/OrganizationsPage';
import VotePage from './pages/VotePage';
import Header from './modules/header/Header';

function App() {
  const [theme, setTheme] = useState({});

  return (
    <ThemeProvider value={{ theme, setTheme }}>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<OrganizationsPage />} />
          <Route path="/vote/:organizationId" element={<VotePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;